export default __webpack_public_path__ + "static/media/img1.3631c04c.png";